export const MAX_SELECTED_PAYMENT_METHODS = 4;
